import { Buttons } from '../../../controls/buttons';
import { Layouts } from '../../../controls/layouts';
import { ChangeDetectionStrategy, Component, computed, inject, linkedSignal, signal, viewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogComponent } from 'src/app/controls/components/advanced/modal-dialog/modal-dialog.component';
import { Password, PasswordComponentValue, PasswordMode } from '../../../controls/password';
import { Textbox } from '../../../controls/textbox';
import { OnboardingCredentials } from 'src/app/partnerportal/components/onboarding-credentials/models/credentials';

@Component({
  selector: 'app-partner-onboarding-provide-credentials-dialog',
  standalone: true,
  imports: [ModalDialogComponent, FormsModule, Buttons, ModalDialogComponent, Layouts, Textbox, Password],
  templateUrl: './partner-onboarding-provide-credentials-dialog.component.html',
  styleUrl: './partner-onboarding-provide-credentials-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PartnerOnboardingProvideCredentialsDialogComponent {
  form = viewChild<NgForm>('form');
  private dialog = inject(NgbActiveModal);
  public credentials = signal<OnboardingCredentials>(null);
  public dialogResult = signal<PartnerOnboardingProvideCredentialsDialogResult>(null);

  PasswordMode = PasswordMode;

  username = linkedSignal(() => {
    const usernameValue = this.credentials()?.Username ?? '';
    return usernameValue;
  });
  password = linkedSignal<PasswordComponentValue>(() => {
    const passwordValue = this.credentials()?.Password ?? '';
    return {
      value: null,
      id: passwordValue
    };
  });

  result = computed(() => {
    const credentials: OnboardingCredentials | null = this.username() || this.password()?.value ? {
        Username: this.username(),
        Password: this.password()?.value ?? this.password()?.id
    } : null;
    const result: PartnerOnboardingProvideCredentialsResult = {
      credentials,
      dialogResult: this.dialogResult()
    };
    return result;
  });

  provide() {
    this.dialogResult.set(PartnerOnboardingProvideCredentialsDialogResult.Provide);
    this.dialog.close(this.result());
  }

  cancel() {
    this.dialogResult.set(PartnerOnboardingProvideCredentialsDialogResult.Cancel);
    this.dialog.close(this.result());
  }
}

export interface PartnerOnboardingProvideCredentialsResult {
  credentials: OnboardingCredentials;
  dialogResult: PartnerOnboardingProvideCredentialsDialogResult;
}

export enum PartnerOnboardingProvideCredentialsDialogResult {
  Provide,
  Cancel
}
